import { CancelOutlined } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { devLog } from "utils/devLog";

const searchTypeMap = new Map();

function DAAMemberSearchForm(props) {
  const { t } = useTranslation();
  const formRef = useRef();
  const [firstName, setFirstName] = useState(props.currState.MemberLookup.firstName || props.currState.FirstName || "");
  const [lastName, setLastName] = useState(props.currState.MemberLookup.lastName || props.currState.LastName || "");
  const [phone, setPhone] = useState(props.currState.MemberLookup.phone || props.currState.Number || "");
  const [postalCode, setPostalCode] = useState(props.currState.MemberLookup.postalCode || "");
  const [memberNumber, setMemberNumber] = useState(props.currState.MemberLookup.memberNumber || "");

  const [moreThanEightVin, setMoreThanEightVin] = useState(false);

  const [searchTypes, setSearchTypes] = useState([
    { key: "NAME", value: t("FIMC.ContractSearch.DropdownOptions3") },
    { key: "PHONE", value: t("FIMC.ContractSearch.DropdownOptions5") },
    { key: "MEMBER_NUMBER", value: t("FIMC.ContractSearch.DropdownOptions1") },
  ]);

  const [selectedSearchTypes, setSelectedSearchTypes] = useState("NAME");

  useEffect(() => {
    devLog(selectedSearchTypes);
    setFirstName(firstName);
    setLastName(lastName);
    setPhone(phone);
    setPostalCode(postalCode);
    setMemberNumber(memberNumber);
  }, [selectedSearchTypes]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        firstName: firstName,
        lastName: lastName,
        memberNumber: memberNumber,
        postalCode: postalCode,
        phone: phone,
        searchType: selectedSearchTypes,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        firstName: firstName,
        lastName: lastName,
        memberNumber: memberNumber,
        postalCode: postalCode,
        phone: phone,
        searchType: selectedSearchTypes,
      });
    }
    return false;
  };

  const vinInputLength = (e) => {
    if (e.target.value.length > 8) {
      e.target.value = e.target.value.slice(0, -1);
      setMoreThanEightVin(true);
      devLog("Vin Length error");
    }
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key == selectedSearchTypes)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchTypes}
                    onClick={(e) => setSelectedSearchTypes(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/*FIRST NAME*/}
          {selectedSearchTypes === "NAME" && (
            <>
              <div className="group-1">
                <div className="label">{t("FIMC.ContractSearch.DropdownSubOptions1")}:</div>
                <input
                  type="text"
                  // placeholder={t("ATF.ContractSearch.DropdownOptions1")}
                  name="firstName"
                  className="input form-control required"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/*LAST NAME*/}
          {selectedSearchTypes === "NAME" && (
            <>
              <div className="group-1">
                <div className="label">{t("FIMC.ContractSearch.DropdownSubOptions2")}:</div>
                <input
                  type="text"
                  // placeholder={t("ATF.ContractSearch.DropdownOptions1")}
                  name="lastName"
                  className="input form-control required"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/*POSTAL CODE*/}
          {selectedSearchTypes === "NAME" && (
            <>
              <div className="group-1">
                <div className="label">{t("FIMC.PolicyInformation.ConfirmCustomerPostalCode")}:</div>
                <input
                  type="text"
                  // placeholder={t("ATF.ContractSearch.DropdownOptions1")}
                  name="postalCode"
                  className="input form-control required"
                  value={postalCode}
                  onChange={(e) => {
                    setPostalCode(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/*PHONE*/}
          {selectedSearchTypes === "PHONE" && (
            <>
              <div className="group-1">
                <div className="label">{t("FIMC.ContractSearch.DropdownOptions5")}:</div>
                <input
                  type="number"
                  // placeholder={t("ATF.ContractSearch.DropdownOptions2")}
                  name="phone"
                  className="input form-control required"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/*MEMBER NUMBER*/}
          {selectedSearchTypes === "MEMBER_NUMBER" && (
            <>
              <div className="group-1">
                <div className="label">{t("FIMC.ContractSearch.DropdownOptions1")}:</div>
                <input
                  type="text"
                  // placeholder={t("ATF.ContractSearch.DropdownOptions3")}
                  name="memberNumber"
                  className="input form-control required"
                  value={memberNumber}
                  onChange={(e) => {
                    setMemberNumber(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
              {/* {moreThanEightVin && (
                <Alert severity="error">
                  {t("description.VinInputErrorMsg")}
                </Alert>
              )} */}
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default DAAMemberSearchForm;
